module.exports = __webpack_public_path__ + "img/10_11.cefe22df.png";